import { ProfileFormData } from "./profile-form-data";
import { FieldError, UseFormRegister } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import { TextField } from "@mui/material";

interface Props {
  register: UseFormRegister<ProfileFormData>;
  editMode: Boolean;
  firstName: string;
  lastName: string;
  firstNameError: FieldError | undefined;
  lastNameError: FieldError | undefined;
}

export const ProfileName = (props: Props) => {
  const { register, editMode, firstName, lastName, firstNameError, lastNameError } = props;
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 3 }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, flexGrow: 1 }}>
        <TextField
          {...register("firstName")}
          defaultValue={firstName}
          variant="filled"
          label={t("account.profilePage.firstNameLabel")}
          //when editMode is false, the field is disabled
          InputProps={{
            readOnly: !editMode,
            style: { backgroundColor: !editMode ? "white" : undefined },
          }}
          fullWidth
          error={!!firstNameError}
          helperText={firstNameError?.message}
        />
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, flexGrow: 1 }}>
        <TextField
          {...register("lastName")}
          defaultValue={lastName}
          variant="filled"
          //when editMode is false, the field is disabled
          InputProps={{
            readOnly: !editMode,
            style: { backgroundColor: !editMode ? "white" : undefined },
          }}
          label={t("account.profilePage.lastNameLabel")}
          fullWidth
          error={!!lastNameError}
          helperText={lastNameError?.message}
        />
      </Box>
    </Box>
  );
};
